const APP = 'COLLEGE';

const createAction = module => action => `${APP}/${module}/${action}`;

export default createAction;
